import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';


import {
    DataForm,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffProvincesDelete(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    useEffect(() => {
        postData('/api/panel/page/taroff-provinces-delete/form-data', {
            id: allProps['id'],
        }).then((response) => {});
    }, []);
    return (
        <PanelBox>
            <Title>حذف استان</Title>
            <DataForm></DataForm>
            {modal && modal}
        </PanelBox>
    );
}
